import configureStore from './configureStore';
import initialState from './initialState';
import { endpointHandlers } from './configureEndpointHandlers';

const store = configureStore(initialState);

export { store, initialState, endpointHandlers };
